<template>
    <vs-row
      vs-justify="center"
      vs-align="center"
      class="login-register-bg mt-4"
    >
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="5"
        vs-mc="7"
        vs-xs="12"
      >

        <vs-card class="position-relative mb-0 pt-3">

            <!-- all service list -->
            <h3 class="mb-3 text-center">{{ $t('mainheading') }}</h3>
            
            <vs-input class="w-100 my-4" v-model="serviceKeyword"/>
            <div vs-justify="start" class="pb-3 px-3 login-register-box">
                <div class="w-100" v-for="service in filteredServices" :key="service.id">
                    <vs-button v-model="selectedService" type="flat"  class="text-left w-100" :href="`/service/${service.sluf}`">{{ service.name }}</vs-button>
                </div>
                <div v-if="filteredServices.length == 0">{{ $t('noSearchResult') }}</div>
            </div>
            <!-- End of all service list -->

        </vs-card>
      </vs-col>
    </vs-row>
  </template>
  
  <script>
  import axios from 'axios';

  export default {
    name: "ServiceList",
    data: () => ({
        serviceList: [],
        filteredServices: [],
        selectedService: [],
        serviceKeyword: '',
    }),

    watch: {
      serviceKeyword() {
        this.filteredServices = this.serviceList.filter((obj) => {
          return obj['name'].toLowerCase().includes(this.serviceKeyword.toLowerCase());
        })
      }
    },

    created() {
        axios
            .get(`${process.env.VUE_APP_API_URL}/public/services`)
            .then(res => {
              this.serviceList = res.data;
              this.filteredServices = this.serviceList;
            })

            console.log(process.env.VUE_APP_API_URL)
    },


    methods: {
        selectService() {
            if(this.selectedService.length > 1) {
                const temp = this.selectedService[this.selectedService.length - 1];
                this.selectedService = [ temp ];
            }
        },

        // checkForm() {
        //     if ( this.selectedService.length == 0) {
        //         this.$vs.notify({
        //             color: "danger",
        //             title: this.$t('serviceErrHead'),
        //             text: this.$t('serviceError')
        //         });
        //         return;
        //     } else {
        //         this.$router.push(`/service/${this.selectedService[0]}`);
        //     }

        // },
    },

  };
  </script>

  <style lang="scss">
  .login-register-bg {
    margin: 0 auto;
  }

  .login-register-box {
    max-height: 55vh !important;
    min-height: 55vh !important;
    overflow-y: auto;
  }

  .back-button {
    position: absolute;
    top: 10px;
    left: 10px; 
  }

  .description {
        .vs-textarea {
            height: 200px;
        }
  }



  </style>
  
  